import React from "react";
import cx from "classnames";
import ConditionalLink from "components/ConditionalLink";
import Icon from "components/CommonIcon/Icon";

const IconLinkButton = ({ btnText, href, smaller, iconName }) => {
  const content = (
    <>
      <span
        className={cx("font-mulish font-semibold text-gold uppercase", {
          "text-12-22 tracking-16": smaller,
        })}>
        {btnText}
      </span>
      <div className="ml-4">
        <Icon name={iconName} fontSize="text-16" />
      </div>
    </>
  );

  return href ? (
    <ConditionalLink link={href} className="flex items-center">
      {content}
    </ConditionalLink>
  ) : (
    <div className="flex items-center">{content}</div>
  );
};

IconLinkButton.defaultProps = {
  iconName: "right-arrow",
};

export default IconLinkButton;
